import NavIconSearch from "@/assets/images/icons/nav-icon-search.svg";
import React, { useState } from "react";
import { Platform, Pressable, View } from "react-native";
import { XStack } from "tamagui";
import { SearchModal } from "./SearchModal";
import { GlobalSearchPanel } from "./GlobalSearchPanel";

const HOVER_ORANGE = "rgba(242, 102, 58, 1)";

export function GlobalSearchManager() {
  const [open, setOpen] = useState(false);
  const [hovered, setHovered] = useState(false);
  const isWeb = Platform.OS === "web";
  const color = isWeb && hovered ? HOVER_ORANGE : "white";

  return (
    <>
      {isWeb ? (
        <div
          onMouseEnter={() => setHovered(true)}
          onMouseLeave={() => setHovered(false)}
          onClick={() => setOpen(true)}
          style={{
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            borderRadius: 6,
            paddingTop: 2,
            paddingBottom: 2,
            paddingLeft: 2,
            paddingRight: 2,
            outlineWidth: 0,
            cursor: "pointer",
          }}
        >
          <NavIconSearch width={36} height={36} color={color} />
        </div>
      ) : (
        <Pressable onPress={() => setOpen(true)} hitSlop={8}>
          <View
            style={{
              borderRadius: 6,
              paddingVertical: 2,
              paddingHorizontal: 2,
            }}
          >
            <XStack ai="center" gap={8}>
              <NavIconSearch width={36} height={36} color="white" />
            </XStack>
          </View>
        </Pressable>
      )}

      <SearchModal open={open} onOpenChange={setOpen}>
        {open ? (
          <GlobalSearchPanel open autoFocusInput onClose={() => setOpen(false)} />
        ) : null}
      </SearchModal>
    </>
  );
}
